import * as constants from './constants';

export function setUnreadMessage(value) {
  return { type: constants.SET_UNREAD_MESSAGE, payload: value };
}

export function setShowBadge(value) {
  return { type: constants.SET_SHOW_BADGE, payload: value };
}
